import React from 'react';
import TextInput from '../UI/TextInput';
import EmailInput from '../UI/EmailInput';
import { useForm } from 'react-hook-form';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ReactComponent as TooltipIcon } from '../../assets/icons/tooltip.svg';
import Select from '../UI/Select';
import { GOVERNMENT_INPUT_LIST, CITY_INSTALLATION_LIST } from '../../constans';

const Frame = ({ onSubmit, setTerms, terms, onChangeHandler, inputValue }) => {
  const { register, handleSubmit, errors } = useForm();

  const onChangeTermsHander = event => {
    const checked = event.target.checked;
    checked ? setTerms(true) : setTerms(false);
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {GOVERNMENT_INPUT_LIST.map(item => {
        const { name } = item;
        if (item.type === 'text') {
          return (
            <fieldset key={item.label}>
              <label htmlFor={item.name}>{item.label} {item.required && <span>*</span>}</label>
              <div className="tooltip-container">
                <TextInput 
                  name={item.name}
                  type={item.type}
                  register={register(item.required && { required: true })}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      {item.tooltip}
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
              {errors[name] && (
                <p className="warnMessage">This field is required</p>
              )}
            </fieldset>
          )
        } else if (item.type === 'email') {
          return (
            <fieldset key={item.label}>
              <label htmlFor={item.name}>{item.label} {item.required && <span>*</span>}</label>
              <div className="tooltip-container">
                <EmailInput 
                  name={item.name}
                  type={item.type}
                  register={register(item.required && { required: true })}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      {item.tooltip}
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
              {errors[name] && (
                <p className="warnMessage">This field is required</p>
              )}
            </fieldset>
          )
        } else if (item.type === "tel") {
          return (
            <fieldset key={item.label}>
              <label htmlFor={item.name}>{item.label} {item.required && <span>*</span>}</label>
              <div className="tooltip-container">
                <input
                  name={item.name}
                  type={item.type}
                  ref={register(item.required && { required: true })}
                  id={item.name}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      {item.tooltip}
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
              {errors[name] && (
                <p className="warnMessage">This field is required</p>
              )}
            </fieldset>
          )
        } else if (item.type === "select") {
          return (
            <fieldset key={item.label}>
              <label htmlFor={item.name}>{item.label} {item.required && <span>*</span>}</label>
              <div className="tooltip-container">
                <Select 
                  handleMultiChange={onChangeHandler}
                  name={item.name}
                  list={CITY_INSTALLATION_LIST}
                  inputValue={inputValue.installation}
                  styles="react-select-input-container"
                  prefixStyles="react-select-input"
                  indicator={false}
                  check={true}
                  isClear={false}
                  components={{ DropdownIndicator:() => null, IndicatorSeparator:() => null }}
                  defaultValue={{value: "Fort Bragg", label: "Fort Bragg", type: "installation"}}
                />
                <OverlayTrigger
                  placement="right"
                  delay={{ show: 250, hide: 400 }}
                  overlay={
                    <Tooltip id="button-tooltip">
                      {item.tooltip}
                    </Tooltip>
                  }
                >
                  <TooltipIcon />
                </OverlayTrigger>
              </div>
            </fieldset>
          )
        }
      })}
      <div className="terms-wrap">
        <div className="Checkbox_Wrap">
          <input
            label="agree"
            onChange={onChangeTermsHander}
            type="checkbox"
            name="agree"
            id="agree"
            checked={terms}
            ref={register()}
          />
          <label htmlFor="agree">I Agree to the <a href="/terms" target="_blank" rel="noreffer">Terms and Conditions</a><span>*</span></label>
        </div>
      </div>
      <button 
        type="submit"
        className="filledBtn btnSizes"
        disabled={!terms}
      >
        Complete Registration
      </button>
    </form>
  )
}

export default Frame;